<template>
  <div class="wrapper">
    <p class="firstPar">Επικοινώνησε με έναν</p>
    <p class="secondPar">Ειδικό δίπλα σου</p>

    <p>Κάλεσε έναν εξειδικευμένο γιατρό</p>

    <img @click="buttonClick" class="image" src="@/assets/dn2me-btn.png" alt />

    <v-btn
      style="position:absolute; bottom:50px;text-transform: none;"
      color="rgb(240,240,240)"
      outlined
      depressed
      @click="$router.push('/how-it-works')"
    >
      <p class="mb-0 black--text font-weight-regular">Πώς λειτουργεί η εφαρμογή</p>
    </v-btn>

    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-text>
          <v-icon
            style="position:absolute; right: 10px; top:10px; cursor: pointer;"
            @click="dialog = false"
          >mdi-close</v-icon>
          <div class="d-flex flex-column align-center justify-center">
            <p class="black--text font-weight-bold mt-10" style="font-size:20px;">Θέλω να μιλήσω με</p>
            <v-radio-group v-model="withDoctor">
             
              <v-radio class="mt-3" color="rgb(0,170,221)" :value="false">
                <template slot="label">
                  <div class="box">
                    <p class="mb-0">Ψυχολόγο</p>
                  </div>
                </template>
              </v-radio>
               <v-radio color="rgb(0,170,221)" :value="true">
                <template slot="label">
                  <div class="box">
                    <p class="mb-0">Ιατρό</p>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>

            <v-autocomplete 
              v-if="withDoctor"
              :items="doctorTypes"
              label="Ειδικότητα"
              v-model="doctorType"
              item-text="option_value"
              item-value="option_key"></v-autocomplete>

            <p
              v-if="!withDoctor"
              class="text-center mb-0 px-3"
              style="font-size:13px; line-height:1"
            >Παρακαλώ λάβετε υπόψην σας ότι η υπηρεσία αυτή δεν πρέπει να χρησιμοποιείται σαν απομακρυσμένη ψυχοθεραπεία αλλά ως απλή συμβουλευτική από τους συνεργαζόμενους ψυχολόγους</p>
            <v-btn
              @click="search"
              width="180"
              height="40"
              rounded
              depressed
              color="rgb(0,170,221)"
              class="white--text text-capitalize mt-9"
            >
              <p class="mb-0 font-weight-regular">Συνέχεια</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="permissionDialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h2
              class="black--text font-weight-bold text-center pa-5"
            >Έχετε απενεργοποιήσει τη χρήση κάμερας ή/και μικροφώνου στον browser σας. Πρέπει να τα ενεργοποιήσετε για να μπορείτε να συνεχίσετε με κάποια βιντεοκλήση.</h2>
            <v-btn
              depressed
              rounded
              color="rgb(0,170,221)"
              class="white--text"
              @click="permissionDialog=false"
            >
              <p class="mb-0">OK</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>-->

    <v-dialog v-model="notYetDialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center pa-5">
            <h2
              class="black--text text-center"
            >Η λειτουργία κλήσης ιατρών δεν είναι προσωρινά διαθέσιμη για τους πολίτες. Θα ενημερωθείτε με προσωπικό μήνυμα ηλεκτρονικού ταχυδρομείου όταν θα είναι διαθέσιμη.</h2>
            <v-btn
              @click="notYetDialog=false"
              class="mt-5 white--text"
              color="rgb(0,170,221)"
              depressed
              rounded
            >
              <p class="mb-0">ΟΚ</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="permissionDialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h3
              class="black--text text-center pa-5"
            >Φαίνεται ότι έχετε απενεργοποιήσει/απαγορεύσει την χρήση κάμερας ή/και μικροφώνου. Παρακαλώ αλλάξτε τις ρυθμίσεις του browser σας για να μπορείτε να κάνετε βιντεοκλήση</h3>
            <v-btn
              depressed
              rounded
              color="rgb(0,170,221)"
              class="white--text"
              @click="permissionDialog=false"
            >
              <p class="mb-0">OK</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="notSupportDialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center pa-5">
            <p class="text-center">O φυλλομετρητής που χρησιμοποιείτε δεν φαίνεται να υποστηρίζει το πρωτόκολλο επικοινωνίας με βίντεο.</p>
            <p class="text-center">{{os === 'ios' ? ' Σε κινητά iPhone υποστηρίζεται μόνο ο Safari.' : ''}}</p>
            <p class="text-center">{{os === 'android' ? ' Σε κινητά Android χρησιμοποιήστε Chrome ή Firefox.' : ''}}</p>
            <v-btn rounded depressed color="rgb(0,170,221)" class="text-capitalize white--text" width="150" height="40" @click="notSupportDialog=false">
              <p class="mb-0">ΟΚ</p>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const DetectRTC = require("detectrtc");
import axios from "axios";
export default {
  // mounted() {

  //     alert(DetectRTC.browser.name + ' ' + DetectRTC.osName + ' ' + DetectRTC.isMobileDevice);

  //   console.log(DetectRTC)
  // },

  created() {
    // navigator.permissions
    //   .query({ name: "camera" })
    //   .then(res => {
    //     //   console.log(res.state);
    //     this.camera = res.state;
    //     return navigator.permissions.query({ name: "microphone" });
    //   })
    //   .then(res => {
    //     this.microphone = res.state;
    //   })
    //   .catch(err => console.log(err));
    
  },

  data() {
    return {
      dialog: false,
      withDoctor: true,
      permissionDialog: this.$store.state.permissionDenied,
      camera: null,
      microphone: null,
      notYetDialog: false,
      notSupportDialog: false,
      os: null,
      
      doctorType: null
    };
  },
  methods: {
    buttonClick() {
      if (
        localStorage.getItem("mobile") &&
        ((localStorage.getItem("os") === "ios" &&
          localStorage.getItem("browser") === "chrome") ||
          (localStorage.getItem("os") === "ios" &&
          localStorage.getItem("browser") === "firefox") ||
          (localStorage.getItem("os") === "android" &&
            localStorage.getItem("browser") === "xiaomi/miuibrowser"))
      ) {
        this.notSupportDialog = true
        this.os = localStorage.getItem("os")
      } else {
        axios
          .get(`${process.env.VUE_APP_BASE_URL}/traveller/isAllowedVideoCall`)
          .then(res => {
            if (
              !res.data &&
              !this.$store.state.user.userProfile.email.includes(
                "mailinator.com"
              )
            ) {
              // console.log("not");
              this.notYetDialog = true;
            } else {
              // if (this.camera === "denied" || this.microphone === "denied") {
              //   this.permissionDialog = true;
              // } else {
              this.dialog = true;
              // }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    search() {
      if (this.withDoctor) {
        this.$router.push(`/emergency/doctors/${this.doctorType === null ? '' : (this.doctorType == 100 ? '' : this.doctorType)}`);
      } else {
        this.$router.push("/emergency/psychologists");
      }
    }
  },

  computed: {
    doctorTypes(){
      return this.$store.state.doctors
    }
  }

  // computed: {
  //   available(){
  //     return this.$store.state.user.isCurrentlyAvailable
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.firstPar {
  margin-top: 100px;
  margin-bottom: 0;
  font-size: 25px;
}

.secondPar {
  font-size: 28px;
  font-weight: bold;
}

.image {
  height: 250px;
  cursor: pointer;
}

.box {
  border: 1px solid black;
  padding: 30px;
  width: 200px;
  text-align: center;
}

@media only screen and (max-width: 600px) {
  .firstPar {
    margin-top: 100px;
  }
}
</style>